import type { ApiError } from '@common/api/graphql/apolloClient';
import { requestGiftCardIssueAmount } from '../../../../common/api/graphql/requestGiftCardIssueAmountGql';
import { createSuccessMessage } from '../../../../common/api/graphql/successMessage';
import {
  requestGiftCardIssueAmountFailure,
  requestGiftCardIssueAmountStart,
  requestGiftCardIssueAmountSuccess
} from '../actions';
import type { AppThunkAction } from '../thunkType';
import handleApiErrorIfNeeded from './handleApiErrorIfNeeded';

const requestGiftCardIssueAmountSuccessThunk =
  (): AppThunkAction<Promise<void>> => dispatch => {
    const snackbarMessage = createSuccessMessage('数量確定');
    dispatch(requestGiftCardIssueAmountSuccess(snackbarMessage));
    return Promise.resolve();
  };

export const requestGiftCardIssueAmountFailureThunk =
  (error: ApiError): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(requestGiftCardIssueAmountFailure());
    return dispatch(handleApiErrorIfNeeded(error));
  };

export const requestGiftCardIssueAmountThunk =
  (issueAmount: number, urlCode: string): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(requestGiftCardIssueAmountStart());

    return requestGiftCardIssueAmount(issueAmount, urlCode)
      .then(() => dispatch(requestGiftCardIssueAmountSuccessThunk()))
      .catch(error => dispatch(requestGiftCardIssueAmountFailureThunk(error)));
  };
